import _get from 'lodash/get';
import { isEmpty } from 'common/utils/data-utils';
import { trackClick, event, cat, custom } from 'common/utils/instrumentation';
import {
  scribeTrackEvent,
  getCommonFacet,
  SCRIBE_STATE_NAMES,
  SCRIBE_DELIVERY_DETAILS_EVENTS,
  SCRIBE_EVENT_PARAMS,
} from 'applications/scribe/instrumentations/track';

export const trackBookOrderForm = (changedValues, companyID) => {
  Object.keys(changedValues).forEach(key => {
    let label;
    if (key.startsWith('name-recipient')) {
      label = 'RECIPIENT_NAME';
    } else if (key.startsWith('phone-recipient')) {
      label = 'RECIPIENT_PHONE';
    } else if (key.startsWith('cod-recipient')) {
      label = 'COD_VALUE';
    } else if (key === 'SERVICE_TYPE') {
      label = 'SERVICE_TYPE';
    } else if (key === 'ITEM_WEIGHT') {
      label = 'ITEM_WEIGHT';
    } else if (key === 'ITEM_TYPE') {
      label = 'ITEM_CATEGORY';
    } else if (key === 'INSTRUCTION') {
      label = 'DRIVER_NOTES';
    } else if (key === 'PAYMENT_METHOD') {
      label = 'PAYMENT_TYPE';
    } else if (key === 'REFERENCE_CODE') {
      label = 'REF_CODE';
    } else if (key === 'PROMO') {
      label = 'PROMO_CODE';
    }
    if (label) {
      trackClick(
        event.DELIVERY_DETAILS_CLICKS,
        cat.GE_DELIVERY_DETAILS,
        label,
        {
          [custom.COMPANY_ID]: companyID,
        },
      );
    }
  });
};

export const scribeTrackBookOrderForm = ({
  changedValues,
  allValues,
  index,
  userInfo,
}) => {
  for (const [key, value] of Object.entries(changedValues)) {
    let eventName, additionalFacet;
    if (key.startsWith('name-recipient')) {
      eventName = SCRIBE_DELIVERY_DETAILS_EVENTS.RECIPIENT_NAME;
      /*
        * [changedValues] value is an object, e.g:
        *
          "ITEM_WEIGHT": {
              "name": "ITEM_WEIGHT",
              "value": 2,
              "touched": true,
              "dirty": false,
              "validating": false
            }
          }
        *
      */
      additionalFacet = {
        [SCRIBE_EVENT_PARAMS.RECIPIENT_NAME_TEXT]: value.value,
      };
    } else if (key.startsWith('phone-recipient')) {
      eventName = SCRIBE_DELIVERY_DETAILS_EVENTS.RECIPIENT_PHONE;
      additionalFacet = {
        [SCRIBE_EVENT_PARAMS.RECIPIENT_PHONE_TEXT]: value.value,
        [SCRIBE_EVENT_PARAMS.RECIPIENT_NAME_TEXT]: isEmpty(index)
          ? _get(allValues, 'name-recipient-0.value')
          : _get(allValues, `name-recipient-${index}.value`),
      };
    } else if (key.startsWith('cod-recipient')) {
      eventName = SCRIBE_DELIVERY_DETAILS_EVENTS.COD_VALUE;
      additionalFacet = {
        [SCRIBE_EVENT_PARAMS.COD_AMOUNT]: value.value,
      };
    } else if (key === 'SERVICE_TYPE') {
      eventName = SCRIBE_DELIVERY_DETAILS_EVENTS.SERVICE_TYPE;
      additionalFacet = {
        [SCRIBE_EVENT_PARAMS.SERVICE_TYPE]: value.value,
      };
    } else if (key === 'ITEM_WEIGHT') {
      eventName = SCRIBE_DELIVERY_DETAILS_EVENTS.ITEM_WEIGHT;
      additionalFacet = {
        [SCRIBE_EVENT_PARAMS.ITEM_WEIGHT]: value.value,
      };
    } else if (key === 'ITEM_TYPE') {
      eventName = SCRIBE_DELIVERY_DETAILS_EVENTS.ITEM_CATEGORY;
      additionalFacet = {
        [SCRIBE_EVENT_PARAMS.CATEGORY_NAME]: value.value,
      };
    } else if (key === 'INSTRUCTION') {
      eventName = SCRIBE_DELIVERY_DETAILS_EVENTS.DRIVER_NOTES;
      additionalFacet = {
        [SCRIBE_EVENT_PARAMS.TEXT]: value.value,
      };
    } else if (key === 'PAYMENT_METHOD') {
      eventName = SCRIBE_DELIVERY_DETAILS_EVENTS.PAYMENT_TYPE;
      additionalFacet = {
        [SCRIBE_EVENT_PARAMS.PAYMENT_METHOD]: value.value,
      };
    } else if (key === 'REFERENCE_CODE') {
      eventName = SCRIBE_DELIVERY_DETAILS_EVENTS.REF_CODE;
      additionalFacet = {
        [SCRIBE_EVENT_PARAMS.TEXT]: value.value,
      };
    } else if (key === 'PROMO') {
      eventName = SCRIBE_DELIVERY_DETAILS_EVENTS.PROMO_CODE;
      additionalFacet = {
        [SCRIBE_EVENT_PARAMS.PROMO_CODE]: value.value,
      };
    }

    if (!isEmpty(eventName)) {
      const facets = {
        ...getCommonFacet(userInfo),
        ...additionalFacet,
      };
      if (!isEmpty(index)) {
        facets[SCRIBE_EVENT_PARAMS.DELIVERY_NUMBER] = index;
      }
      scribeTrackEvent({
        stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB,
        eventName,
        facets,
      });
    }
  }
};
